import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomerDepartmentState } from '../reducers/base-customer-department.reducer';

const getCustomerDepartmentState = createFeatureSelector<CustomerDepartmentState>('customerDepartment');

export const getCustomerDepartment = createSelector(getCustomerDepartmentState, (state) => state.department);
export const getCustomerUsers = createSelector(getCustomerDepartmentState, (state) => state.customerUsers);
export const getCustomerActiveUsers = createSelector(getCustomerDepartmentState, (state) => state.customerActiveUsers);

export const getRequirementCategories = createSelector(
  getCustomerDepartmentState,
  (state) => state.requirementCategories
);

export const getCustomerDepartmentCrud = createSelector(getCustomerDepartmentState, (state) => state.crud);
